module.exports = __webpack_public_path__ + "static/img/juice_3.3360a05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/juice_3.png
// module id = 9WqJ
// module chunks = 0